import { render, staticRenderFns } from "./ContentfulSyncView.vue?vue&type=template&id=69854add"
import script from "./ContentfulSyncView.vue?vue&type=script&lang=js"
export * from "./ContentfulSyncView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports